import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class Quebec extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription"> 
                    <h1>{DojoRepository.QUEBEC.name}</h1>
                    <p>Québec Shotokan a été fondé par Sensei Denis Houde en septembre 1985. Situé au cœur de la ville de Québec, dans l'édifice des Loisirs Montcalm au 265 boulevard René-Lévesque Ouest, le dojo Québec Shotokan a été construit et aménagé spécifiquement pour la pratique du karaté. Les membres ont accès à diverses commodités telles qu’un petit gymnase, vestiaires, douches et stationnements.</p>
                    <p>Le dojo offre des cours aux enfants, ados, hommes et femmes à partir de 5 ans. Chacun évolue à son rythme et s'implique à sa mesure. Un esprit d'entraide et de camaraderie règne dans le groupe et motive les gens à maintenir un entrainement régulier.</p>
                    <p>Les membres du dojo s'impliquent activement et prennent part à l'organisation des compétitions, des stages de perfectionnement et autres activités de <strong>QUÉBEC ISKF</strong> membre de <strong>International Shotokan Karate Federation</strong>. Plusieurs membres du dojo sont des compétiteurs de haut calibre qui se distinguent aux championnats provinciaux, nationaux et internationaux.</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                    <p>
                        <strong>Fondateur et instructeur en chef</strong><br />
                        {DojoRepository.QUEBEC.contact.denis.fullName} - {DojoRepository.QUEBEC.contact.denis.rank}
                    </p>
                    <p>
                        <strong>Assistants instructeurs</strong><br />
                        Marc Caron - 5e Dan<br />
                        Céline Servais - 4e Dan<br />
                        Denis Laferrière - 4e Dan<br />
                        Aurélie Étienne - 2e Dan<br />
                        Audrey Paquette - 1er Dan<br />
                        Marie-Hélène Mainguy - 1er Dan<br />
                        Marie-France Gobeil Solasse - 2e Kyu
                    </p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                    <p>Le dojo est ouvert 6 jours par semaine. L'horaire habituel propose des entraînements dirigés pour des groupes d'élèves débutants, intermédiaires et avancés, le midi et le soir en semaine et le samedi matin. Des cours privés et des ateliers de pratique libre sont aussi disponibles.</p>
                    <p>Des cours aux enfants sont offerts pour les groupes d’âge suivants : les petits tigres de 5-6 ans, cours d’initiation au karaté, les grands tigres de 7-8 ans et les ados de 9-14 ans. L’horaire prévoit 2 entraînements par semaine pour le groupe des ados et 1 entraînement pour les tigres de 5-8 ans.</p>
                    
                    <p><strong>Lundi</strong></p>
                    <p>
                        12h00 - Entraînement libre<br />
                        18h00 - Bleues, brunes et noires<br />
                        19h00 - Jaunes à vertes<br />
                        19h00 - Débutants
                    </p>
                    <p><strong>Mardi</strong></p>
                    <p>
                        12h00 - Avancés
                    </p>
                    <p><strong>Mercredi</strong></p>
                    <p>
                        12h00 - Entraînement libre<br />
                        18h00 - Bleues, brunes et noires<br />
                        19h00 - Jaunes à vertes<br />
                        19h00 - Débutants
                    </p>
                    <p><strong>Jeudi</strong></p>
                    <p>
                        12h00 - Avancés<br />
                        17h30 - Noires<br />
                        18h30 - 9 ans et plus
                    </p>
                    <p><strong>Vendredi</strong></p>
                    <p>
                        12h00 - Entraînement libre
                    </p>
                    <p>
                        <strong>Samedi</strong>
                    </p>
                    <p>
                        9h00 - Enfants 5 à 8 ans<br />
                        10h00 - Adoslescents<br />
                        11h00 - Adultes pour tous
                    </p>
                </section>
                <p>&nbsp;</p>

                <section id="dojoPrices"> 
                    <h1>Tarifs</h1>
                    <table border="1" class="price-table" cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs <strong>Enfants et Ados</strong></td>
                            </tr>
                            <tr>
                                <td class="description-column" >5-6 ans</td>
                                <td class="price-column" >10 sem - 105$</td>
                            </tr>
                            <tr>
                                <td class="description-column" >7-8 ans</td>
                                <td class="price-column" >12 sem - 130$</td>
                            </tr>
                            <tr>
                                <td class="description-column" >9-14 ans débutants</td>
                                <td class="price-column" >17sem - 145$ / 2 cours semaine</td>
                            </tr>
                            <tr>
                                <td class="description-column" >9-14 ans intermédiaires et plus</td>
                                <td class="price-column" >17sem - 195$ / 2 cours semaine</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <table border="1" class="price-table"  cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs <strong>Débutants - Adultes</strong></td>
                            </tr>
                            <tr>
                                <td class="description-column" >Session</td>
                                <td class="price-column" >14 sem/ 195$ / 2 cours semaine</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <table border="1" class="price-table"  cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs <strong>Intermédiaires et Avancés - Adultes</strong></td>
                            </tr>
                            <tr>
                                <td class="description-column" >Session (4 mois)</td>
                                <td class="price-column" >250$</td>
                            </tr>
                            <tr>
                                <td class="description-column" >Mois</td>
                                <td class="price-column" >80$</td>
                            </tr>
                            <tr>
                                <td class="description-column" >Carte de 10 cours</td>
                                <td class="price-column" >150$</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p>Notes:</p>
                    <div>
                        <em>1. Les taxes sont incluses dans le prix</em><br />
                        <em>2. Une cotisation <strong>annuelle</strong> à l'organisation provinciale <strong>QUÉBEC ISKF</strong> de <strong>45$</strong> pour adultes 18 ans et plus et de <strong>40$</strong> pour les 7 à 17 ans est obligatoire pour tous les membres. De plus, la carte des Loisirs Montcalm est requise au coût de <strong>12$</strong> par année.</em>
                    </div>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>Instructeur en chef</strong><br />
                        Sensei {DojoRepository.QUEBEC.contact.denis.fullName}<br />
                        {DojoRepository.QUEBEC.contact.denis.phone1}<br />
                        <span class="link-like">{DojoRepository.QUEBEC.contact.denis.email1}</span><br />
                        <span class="link-like">{DojoRepository.QUEBEC.contact.denis.email2}</span>
                    </p>
                    <p>
                        <strong>{DojoRepository.QUEBEC.name}</strong><br />
                        {DojoRepository.QUEBEC.address.buildingName}<br />
                        {DojoRepository.QUEBEC.address.line1}<br />
                        {DojoRepository.QUEBEC.address.city}<br />
                        {DojoRepository.QUEBEC.address.postalCode}<br />
                        <a href={DojoRepository.QUEBEC.links.googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.QUEBEC.name}>Google Maps</a>
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.QUEBEC.geo}>
                        <Marker position={DojoRepository.QUEBEC.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(Quebec);



// WEBPACK FOOTER //
// ./src/pages/dojo/Quebec.js